// Vendor
import * as React from 'react';

// Internal
import { Image } from '@src/components/Image/Image';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';
import { SlideReveal } from '@src/components/SlideReveal/SlideReveal';

const ResaleMostEco: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-xl">
        Resale is the Most Eco-Friendly Way to Get Rid of Unwanted Clothing
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-3 md:gap-24">
        <div className="col-span-2">
          <h2
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 1}
            className="max-w-md mb-8"
          >
            Giving a dress a second life reduces its CO2e impact by 79%.
          </h2>
          <SlideReveal>
            <div className="flex items-center justify-around mb-8">
              <div style={{ width: 212 }}>
                <Image
                  alt="Landfill Icon"
                  fileName="landfill-icon.png"
                  maxWidth={424}
                />
                <p className="text-center">
                  <strong>Landfill</strong> <br />
                  12.7 lbs of CO2e
                </p>
              </div>
              <div style={{ width: 80 }}>
                <Image alt="vs" fileName="vs-icon.png" maxWidth={184} />
              </div>
              <div style={{ width: 170 }}>
                <Image
                  alt="Landfill Icon"
                  fileName="reuse-icon.png"
                  maxWidth={424}
                />
                <p className="text-center mt-1">
                  <strong>Reuse via Resale Platform</strong> <br />
                  2.7 lbs of CO2e
                </p>
              </div>
            </div>
          </SlideReveal>
          <p
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 2}
            className="tup-description mt-8"
          >
            Environmental impact of discarding a single dress<sup>6</sup>
          </p>
        </div>

        <div
          {...DEFAULT_SAL_PROPS}
          data-sal="fade"
          data-sal-delay={SAL_DELAY * 3}
          className=" bg-gray-0 text-center pt-8 pb-8 mt-8 md:mt-0"
        >
          <span className="tup-number font-bold">100 million</span>
          <p className="pr-8 pl-8">
            items have been recirculated by thredUP, displacing{' '}
            <strong>1.74B lbs of CO2e.</strong>
          </p>
          <Image
            {...DEFAULT_SAL_PROPS}
            alt="Choose Used T-Shirt"
            className="m-auto"
            fileName="6a-choosedUsedShirt.jpg"
            maxWidth={280}
          />
          <p className="mt-8 pr-4 pl-4">
            That’s the equivalent of <strong>90K</strong> trips around the
            world.<sup>6, 8</sup>
          </p>
        </div>
      </div>
    </div>
  );
};

export { ResaleMostEco };
